import dayjs from "dayjs";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import type { CashHistoryRes } from "@/types/api/gullak-cash/cash-history";
import { getBizTypeLabelKey } from "../../constants/biz-type";
import clsx from "clsx";
import { isNil } from "lodash-es";
import { useTranslations } from "next-intl";
import { getCurrencyIcon, useGetStaticResource } from "@/services/static-resource";
import { CURRENTY_CODE_MAP } from "@/features/referral/constants";
import Image from "next/image";

type HistoryItem = NonNullable<CashHistoryRes['gulla_clash_history']>[0];

interface CashHistoryListProps {
  data: HistoryItem[];
}

export default function CashHistoryList({ data }: CashHistoryListProps) {
  const { formatCurrencyDetail } = useBalanceFormatter();
  const t_gullak = useTranslations('gullak');
  const { data: staticResource } = useGetStaticResource();

  return (
    <div className="px-4">
      {data.map((item, index) => {
        const currencyIcon = getCurrencyIcon(item.currency || 'INR', staticResource);
        return (
          <div key={item.id || index}>
            <div className="flex items-center justify-between py-4">
              {/* 金额 */}
              <div className="flex-1 flex items-center gap-1">
                <div className={clsx("text-left text-ss font-bold",
                  !isNil(item?.amount) && +(item?.amount) < 0 ? "text-[#e8370c]" : "text-[#39FE55]")}>
                  {item.amount && item.currency
                    ? `${+(item?.amount) > 0 ? '+' : ''}${formatCurrencyDetail(Number(item.amount))}`
                    : '--'}
                </div>
                <Image
                  src={currencyIcon}
                  alt={CURRENTY_CODE_MAP[item.currency || 'INR']}
                  width={12}
                  height={12}
                  className="rounded-full"
                />
              </div>

              {/* 类型 */}
              <div className="flex-1 text-left text-secondary text-ss font-normal">
                {t_gullak(getBizTypeLabelKey(item.biz_type) as any)}
              </div>

              {/* 时间 */}
              <div className="flex-1 text-right text-tertiary text-ss">
                {item.created_at
                  ? dayjs(item.created_at * 1000).format('DD/MM HH:mm:ss')
                  : '--'}
              </div>
            </div>

            {/* 分割线 */}
            <div className="h-[1px] bg-[rgba(214,234,255,0.06)]" />
          </div>
        );
      })}
    </div>
  );
}
